/**
 * @generated SignedSource<<3b8154d92221139df8e234d5c0a3c171>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type columnPicker_issueViewChildIssuesPanel$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueTableColumnPicker_ColumnConfig">;
  readonly " $fragmentType": "columnPicker_issueViewChildIssuesPanel";
};
export type columnPicker_issueViewChildIssuesPanel$key = {
  readonly " $data"?: columnPicker_issueViewChildIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "columnPicker_issueViewChildIssuesPanel",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueTableColumnPicker_ColumnConfig"
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "03e2a790a9486bf8518833eb90e65d5f";

export default node;
